/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Rpc from 'fierry/flux/entity/rpc';
import DynamicElement from 'fierry/rpc.old/dynamic-element';

import Session from 'galax/rpc/session';
import RootModel from 'galax/server/root';

import * as Translator from 'galax/rpc/translator';


export default new Rpc('galax', class extends DynamicElement
{
  constructor ()
  {
    super(RootModel);

    this.createElement('galaxy', new Session());

    this.createRecord('currentTime', [ Translator.CurrentTime ]);
  }
});
